export interface ReportSubpageData {
  key: string
  title: string
  componentFunc: React.FunctionComponent
  getIcons?: CallableFunction
  hasFilter?: boolean
}

export enum ReportSubpageName {
  Overview = 'overview',
  Details = 'details',
  Preview = 'preview',
  Url_details = 'url_details',
  Threat_indicators = 'threat_indicators',
  Disassembly = 'disassembly',
  Emulation_data = 'emulation_data',
  Ioc = 'ioc',
  Strings = 'strings',
  Files = 'files',
  Yara = 'yara',
  Osint = 'osint',
  Geolocation = 'geolocation',
  Similarity_search = 'similarity_search',
}

export interface AllReportSubpages {
  [key: string]: ReportSubpageData
}

export interface MenuTabData {
  key: string
  title: string
  active: boolean
}
